import React from "react";
import ServiceFrontEnd from "components/ServiceFrontEnd";
import WorkMidCopy from "components/WorkMidCopy";
import WorkMidThirdCopy from "components/WorkMidThirdCopy";
import WorkMidBox from "components/WorkMidBox";
import FrontendKeywords from "components/FrontendKeywords";

export default function ServiceFrontend() {
  return (
    <>
      <div className="app-services">
        <section className="service-frontend-wrap">
          <ServiceFrontEnd />
        </section>
        <section className="services-mid-copy">
          <WorkMidCopy />
          <WorkMidBox />
          <WorkMidThirdCopy />
        </section>
        <FrontendKeywords />
      </div>
    </>
  );
}
